<script>
import baseList from "@/views/components/base/baseList.vue";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "notice",
        key: "noticeId",
        url: {
          del: "/admin/system/notice",
        },
        output: false,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          type: "info",
          auth: "",
        },
      ],
      menus: [],
      query: {},
      filters: [
        {
          label: "标题",
          KeyEnter: this.search,
          name: "title",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "公告标题",
          key: "noticeTitle",
          minWidth: 160,
          align: "center",
        },
        {
          title: "公告内容",
          key: "noticeContent",
          minWidth: 220,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.noticeContent;
            return h(
              "span",
              {
                style: {
                  "font-size": "14px",
                },
              },
              text
            );
          },
        },
        {
          title: "创建时间",
          width: 150,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          width: 160,
          key: "handle",
          handle: ["edit", "delete"],
        },
      ],
    };
  },
  created() {},
  methods: {
    toAdd() {
      $utils.url.push({
        name: "engineer_notification_edit",
        query: { action: "add" },
      });
    },
    handleEdit(currentRow) {
      console.log(currentRow);

      let kv = currentRow.noticeId;
      $utils.url.push({
        name: "engineer_notification_edit",
        query: { action: "edit", kv },
      });
    },
  },
};
</script>
